import { KYMW1704Component } from './kymw1704.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * 画像個別登録画面の値を管理するクラス
 *
 * @export KYMW1704Model
 * @class KYMW1704Model
 */
export class KYMW1704Model {

  kymw1704Component: KYMW1704Component;

  // 項番2231 START 障害管理No.U01122対応
  // 選択画像ファイル
  public imageFile: string = <string>'';
  // 項番2231 END 障害管理No.U01122対応
  // 画像ID
  public imageID: string = <string>'';
  // 使用開始受注コード
  public startOrderCode: string = <string>'';
  // 項番2473 START 連合会問合せNo.33対応
  // // 使用開始配達企画回(翌週)
  // public startOrderDelivCatalogID: string = <string>'';
  // 項番2473 END   連合会問合せNo.33対応
  // 使用終了受注コード
  public endOrderCode: string = <string>'';
  // 項番2473 START 連合会問合せNo.33対応
  // // 使用終了配達企画回(翌週)
  // public endOrderDelivCatalogID: string = <string>'';
  // 項番2473 END   連合会問合せNo.33対応
  // 無期限
  public endOrderNothing: boolean = <boolean>true;
  // 今回のみ
  public endOrderEqual: boolean = <boolean>false;
  // 画像名
  public imageName: string = <string>'';
  // 画像ファイル名
  public imageFileName: string = <string>'';
  // ステータス
  public status: string = <string>'';
  // Ｐコード（選択値、入力値）
  public pCode: string = <string>'';
  // Ｐコードリスト
  public pCodeList: Array<any> = null;
  // 商品案内用商品名
  public guideGoodsName: string = <string>'';
  // 商品案内用規格名
  public guideStandardName: string = <string>'';
  // 備考
  public remarks: string = <string>'';
  // 調理例掲載区分
  public cookingExPublish: boolean = <boolean>false;
  // サンプル発注先コード
  public sampleOrderingCode: string = <string>'';
  // サンプル発注先コード名
  public sampleSupplierNameKanji: string = <string>'';
  // 請求先コード
  public billingCode: string = <string>'';
  // 請求先コード名
  public billingSupplierNameKanji: string = <string>'';
  // 請求対象
  public billingTargetDiv: boolean = <boolean>false;
  // 料理名
  public cookingName: string = <string>'';
  // 材料名
  public materialName: string = <string>'';
  // キーワード
  public keyWord: string = <string>'';
  // 撮影指示内容
  public photoInstructContents: string = <string>'';
  // 撮影予定日
  public photoSchedule: string = <string>'';
  // キャプション
  public textCaption: string = <string>'';
  // 所属選択値
  public imageBelongID: string = <string>'';
  // 画像種類選択値
  public imageKind: string = <string>'';
  // 画像種別選択値
  public imageType: string = <string>'';
  // 加工指示選択値
  public processInstruct: string = <string>'';
  // 料理分類選択値
  public cookingDiv: string = <string>'';
  // 季節・催事選択値
  public eventID: string = <string>'';
  // 撮影内容区分選択値
  public photoContentsDiv: string = <string>'';
  // 撮影場所選択値
  public studioName: string = <string>'';
  // 撮影場所選択値
  public studioId: string = <string>'';

  // Ｐコードチェック時のフラグ
  // 0：存在チェック（入力）、1：パラメータ設定、2：存在チェック（登録）
  public pCodeSts: number = <number>0;
  // 商品マスタより所得した該当Ｐコードの承認状態
  public admitStatus: string = <string>'';
  // サーバ一時PNGファイル名
  public tempPNGFileName: string;
  // サーバ一時EPSファイル名
  public tempEPSFileName: string;
  // サーバ一時JPG(S)ファイル名
  public tempJPGSFileName: string;
  // サーバ一時JPG(M)ファイル名
  public tempJPGMFileName: string;
  // サーバ一時JPG(L)ファイル名
  public tempJPGLFileName: string;

  public pngFileRef: File;
  public epsFileRef: File;
  public jpgSFileRef: File;
  public jpgMFileRef: File;
  public jpgLFileRef: File;

  // 活性・非活性用
  /** 使用終了受注コードを非活性 */
  public endOrderCodeEnabled = false;
  /** 調理指示を非活性 */
  public processInstructEnabled = false;


  /**
   * /KYMW0C/getPCodeData.xml発行後のコールバックメソッド
   * Ｐコード存在チェック時
   *
   * @param serverData 該当情報
   */
  public checkPCodeData(serverData: any): void {
    // サーバからの受信データに値が入っているか確認する
    if (serverData != null) {
      if (!PlessViewUtilsSub.isEmpty(serverData.PCode)) {
        this.pCode = serverData.PCode;
        this.admitStatus = serverData.AdmitStatus;
      } else {
        this.pCode = '';
        this.admitStatus = '';
      }
    } else {
      this.pCode = '';
    }

    // フラグにより、メッソッドを振り分け
    if (this.pCodeSts === 0) {
      this.kymw1704Component.checkPCodeData();
    } else {
      this.kymw1704Component.checkPCodeRegist();
    }
  }

  /**
   * /KYMW0C/getPCodeData.xml発行後のコールバックメソッド
   * Ｐコード入力時の設定時
   *
   * @param serverData 該当情報
   */
  public setPCodeData(serverData: any): void {

    // サーバからの受信データに値が入っているか確認する
    if (serverData == null) {
      return;
    }

    if (!PlessViewUtilsSub.isEmpty(serverData.AdmitStatus) && serverData.AdmitStatus === '2') {
      // 取得情報を設定
      // 商品案内用商品名
      this.guideGoodsName = serverData.GuideGoodsName;
      // 商品案内用規格名
      this.guideStandardName = serverData.GuideStandardName;
      this.sampleOrderingCode = serverData.SampleOrderingCode;
      // サンプル発注先コード名
      this.sampleSupplierNameKanji = serverData.SampleSupplierNameKanji;
      // 請求先コード
      this.billingCode = serverData.BillingCode;
      // 請求先コード名
      this.billingSupplierNameKanji = serverData.BillingSupplierNameKanji;

    } else {
      this.kymw1704Component.dialogService.openAlertGetMessage('E0207', ['Ｐコード', '「2：本登録」前', '画像個別登録']);
    }
  }
  /**
   * /KYMW0C/getSupplierName.xml発行後のコールバックメソッド
   * サンプル発注先コード設定する。
   * @param serverData ユーザーリストのサーバ取得データ
   */
  public setSampleOrderingName(serverData: any): void {
    // サーバからの受信データに値が入っているか確認する
    if (serverData != null) {
      // サンプル発注先コードより取得した名称を設定
      this.sampleSupplierNameKanji = serverData.SupplierNameKanji;
    }
  }

  /**
   * /KYMW0C/getSupplierName.xml発行後のコールバックメソッド
   * 請求先コード設定する。
   * @param serverData ユーザーリストのサーバ取得データ
   */
  public setBillingName(serverData: any): void {
    // サーバからの受信データに値が入っているか確認する
    if (serverData != null) {
      // 請求先コードより取得した名称を設定
      this.billingSupplierNameKanji = serverData.SupplierNameKanji;
    }
  }

  /**
   * /KYMW0C/getImageInfo.xml発行後のコールバックメソッド
   *
   * @param serverData ユーザーリストのサーバ取得データ
   */
  public setImageInfo(serverData: any): void {

    // サーバからの受信データに値が入っているか確認する
    if (serverData != null) {
      // 画像ＩＤ
      this.imageID = serverData.ImageID;
      // 使用開始受注コード
      this.startOrderCode = serverData.StartOrderCode;
      // 画像名
      this.imageName = serverData.ImageName;
      // 画像ファイル名
      this.imageFileName = serverData.ImageFileName;
      // 所属
      this.imageBelongID = serverData.ImageBelongId;
      // 画像種類
      this.imageKind = serverData.ImageKind;
      // 画像種別
      this.imageType = serverData.ImageType;
      // 加工指示
      this.processInstruct = serverData.ProcessInstruct;
      // 備考
      this.remarks = serverData.Remarks;
      // 調理例掲載区分のチェックボックス設定
      this.cookingExPublish = (serverData.CookingExPublish === '0') ? false : true;
      // 請求対象のチェックボックス設定
      this.billingTargetDiv = (serverData.BillingTargetDiv === '0') ? false : true;
      // Ｐコード
      this.pCode = serverData.PCode;
      // 商品案内用商品名
      this.guideGoodsName = serverData.GuideGoodsName;
      // 商品案内用規格名
      this.guideStandardName = serverData.GuideStandardName;
      // サンプル発注先コード
      this.sampleOrderingCode = serverData.SampleOrderingCode;
      // サンプル発注先コード名
      this.sampleSupplierNameKanji = serverData.SampleSupplierNameKanji;
      // 請求先コード
      this.billingCode = serverData.BillingCode;
      // 請求先コード名
      this.billingSupplierNameKanji = serverData.BillingSupplierNameKanji;
      // 料理分類
      this.cookingDiv = serverData.CookingDiv;
      // 料理名
      this.cookingName = serverData.CookingName;
      // 材料名
      this.materialName = serverData.MaterialName;
      // キーワード
      this.keyWord = serverData.KeyWord;
      // 季節・催事
      this.eventID = serverData.EventID;
      // 撮影内容区分
      this.photoContentsDiv = serverData.PhotoContentsDiv;
      // 撮影指示内容
      this.photoInstructContents = serverData.PhotoInstructContents;
      // 撮影予定日
      this.photoSchedule = (serverData.PhotoSchedule == null) ? '' : PlessViewUtilsSub.editDate(serverData.PhotoSchedule, '2');

      // 撮影場所
      this.studioName = serverData.PhotoStudioName;
      this.studioId = serverData.PhotoStudioId;
    }
  }

  /**
   * /KYMW0C/getImageName.xml発行後のコールバックメソッド
   *
   * @param serverData ユーザーリストのサーバ取得データ
   */
  public setImageName(serverData: any): void {
    // サーバからの受信データに値が入っているか確認する
    if (serverData != null) {
      // 画像名を設定
      this.imageName = serverData.ImageName;
    }
  }

}
